"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunaTrainStation = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const TileType_1 = require("../../TileType");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
const MoonCard_1 = require("./MoonCard");
const PlaceSpecialMoonTile_1 = require("../../moon/PlaceSpecialMoonTile");
const CardRequirements_1 = require("../CardRequirements");
const Card_1 = require("../Card");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
class LunaTrainStation extends MoonCard_1.MoonCard {
    constructor() {
        super({
            name: CardName_1.CardName.LUNA_TRAIN_STATION,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.BUILDING],
            cost: 20,
            productionBox: Units_1.Units.of({ megacredits: 4 }),
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.logisticRate(5)),
            reserveUnits: Units_1.Units.of({ steel: 2 }),
            tr: { moonLogistics: 1 },
            metadata: {
                description: 'Requires a Logistic Rate of 5 or higher. Spend 2 steel. ' +
                    'Increase your M€ production 4 steps. Place this tile on the Moon and raise the Logistic Rate 1 step. ' +
                    '2 VP FOR EACH ROAD TILE ADJACENT TO THIS TILE.',
                cardNumber: 'M15',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.minus().steel(2).digit;
                    b.production((pb) => pb.megacredits(4));
                    b.tile(TileType_1.TileType.LUNA_TRAIN_STATION, true).moonLogisticsRate();
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.moonRoadTile(2, true),
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        const moonData = MoonExpansion_1.MoonExpansion.moonData(player.game);
        const spaces = moonData.moon.getAvailableSpacesOnLand(player);
        if (spaces.length === 0)
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        super.play(player);
        player.game.defer(new PlaceSpecialMoonTile_1.PlaceSpecialMoonTile(player, {
            tileType: TileType_1.TileType.LUNA_TRAIN_STATION,
            card: this.name,
        }, 'Select a space for Luna Train Station.'));
        MoonExpansion_1.MoonExpansion.raiseLogisticRate(player);
        return undefined;
    }
    getVictoryPoints(player) {
        const moonData = MoonExpansion_1.MoonExpansion.moonData(player.game);
        const usedSpace = moonData.moon.getSpaceByTileCard(this.name);
        if (usedSpace !== undefined) {
            const adjacentSpaces = moonData.moon.getAdjacentSpaces(usedSpace);
            const adjacentMines = adjacentSpaces.filter((s) => MoonExpansion_1.MoonExpansion.spaceHasType(s, TileType_1.TileType.MOON_ROAD));
            return 2 * adjacentMines.length;
        }
        return 0;
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainProductionFromMoonTrackIncrease(this.tr) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, moonLogisticsRateIncrease: 1, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.LunaTrainStation = LunaTrainStation;
//# sourceMappingURL=LunaTrainStation.js.map